import AppDispatcher from '../dispatcher/AppDispatcher';
import BeneficiarySyncConstants from '../constants/BeneficiarySyncConstants';
import BeneficiarySyncParser from '../parsers/BeneficiarySyncParser';
class BeneficiarySyncActionCreator {
  fetchBeneficiaryToSync() {
    AppDispatcher.handleServerAction({
      actionType: BeneficiarySyncConstants.FETCH_BENEFICIARY_TO_SYNC,
    });
  }

  addBeneficiary(benData, associatedAccountId) {
    const beneficiaryParser = new BeneficiarySyncParser();
    AppDispatcher.handleServerAction({
      actionType: BeneficiarySyncConstants.ADD_BENEFICIARY,
      data: beneficiaryParser.getBeneficiariesToSync(benData),
      id: associatedAccountId,
    });
  }

  handleFetchSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: BeneficiarySyncConstants.FETCH_BENEFICIARY_SUCCESSS,
      data: response,
    });
  }

  handleFetchFail(response) {
    AppDispatcher.handleServerAction({
      actionType: BeneficiarySyncConstants.FETCH_BENEFICIARY_FAIL,
      data: response,
    });
  }

  handleSyncSuccess(response = null, associatedAccountId = '') {
    AppDispatcher.handleViewAction({
      actionType: BeneficiarySyncConstants.ADD_BENEFICIARY_SUCCESSS,
      data: response,
      id: associatedAccountId,
    });
  }

  handleSyncFail() {
    AppDispatcher.handleViewAction({
      actionType: BeneficiarySyncConstants.ADD_BENEFICIARY_FAIL,
    });
  }
}

export default new BeneficiarySyncActionCreator();
